import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
  XAxis,
  YAxis
} from "recharts";

import { colors } from "./theme";

interface BarChartComponentProps {
  data: Array<{
    type: string;
    avgTime: number;
  }>;
}

export const BarChartComponent: React.FC<BarChartComponentProps> = ({
  data
}) => (
  <ResponsiveContainer width="100%" height={200}>
    <BarChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={colors.neutral2 + "30"} />
      <XAxis
        dataKey="type"
        tick={{ fill: colors.primary }}
        tickLine={{ stroke: colors.neutral2 }}
      />
      <YAxis
        tick={{ fill: colors.primary }}
        tickLine={{ stroke: colors.neutral2 }}
        label={{
          value: "Hours",
          angle: -90,
          position: "insideLeft",
          style: { fill: colors.primary }
        }}
      />
      <RechartsTooltip
        contentStyle={{
          backgroundColor: "#fff",
          borderColor: colors.neutral2,
          borderRadius: "4px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
        }}
        formatter={(value) => [`${value} hours`, "Avg. Completion Time"]}
      />
      <Bar
        dataKey="avgTime"
        fill={colors.accent1}
        name="Average Completion Time"
        radius={[4, 4, 0, 0]}
      >
        {data.map((entry, index) => (
          <Cell
            key={`cell-${index}`}
            fill={colors.chartColors[index % colors.chartColors.length]}
          />
        ))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);